import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-595b1bd9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "data ws_mr5" }
const _hoisted_2 = { class: "address" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "ws_drawer_footer" }

import { ref, watch, computed } from 'vue'
import type { FormInstance } from 'element-plus'
import { ElMessage } from 'element-plus'
import {
  passwordReg,
  phoneReg,
  telPhoneReg,
  accountReg,
  CODE_ENUM,
} from '@/common'
import Text from '@/components/text'
import MapModal from '@/components/map-modal-drawer'
import { createTenantInfo, updateTenantInfo, queryTenantInfo } from '@/api'
import { encode } from '@/utils'


export default /*#__PURE__*/_defineComponent({
  __name: 'tenant-form-drawer',
  props: ['visible', 'data'],
  emits: ['update:visible', 'success'],
  setup(__props, { emit: __emit }) {

const $emit = __emit
const props = __props

watch(
  () => props.visible,
  () => {
    if (props.visible) {
      queryDetail()
    }
  }
)

const formData = ref({
  address: '',
  orgContact: '',
  orgMobile: '',
  orgName: '',
  salePerson: '',
  superPassword: '',
  superUsernmae: '',
  confirmPassword: '',
  superMobile: '',
})

const mapData: any = ref({
  address: '',
  lng: '',
  lat: '',
})

const detailLoading = ref(false)
const queryDetail = async () => {
  const orgId = props.data.orgId
  if (!orgId) {
    return
  }
  detailLoading.value = true
  const res: any = await queryTenantInfo({
    orgId,
  })
  detailLoading.value = false
  if (res?.code === CODE_ENUM.SUCCESS) {
    const { address, locationLat, locationLon, ...p } = res.data
    formData.value = {
      address,
      ...p,
    }
    mapData.value = {
      address,
      lng: locationLon,
      lat: locationLat,
    }
  }
}

const mapConf = ref({
  visible: false,
})
const toShowMap = () => {
  mapConf.value.visible = true
}

const cancel = () => {
  $emit('update:visible', false)
  formRef.value.resetFields()
  mapData.value = {
    address: '',
    lng: '',
    lat: '',
  }
}

const onMapChange = (mo: any) => {
  mapData.value = mo
  formData.value.address = mo.address
  formRef.value.validateField('address')
}

const validatorLocation = (rule: any, value: any, callback: any) => {
  const { address, lng, lat } = mapData.value
  if (!address || !lng || !lat) {
    callback('请选择')
  } else {
    callback()
  }
}

const vailidateMethod = (reg: RegExp, msg: string) => {
  return (rule: any, value: any, callback: any) => {
    if (reg.test(value)) {
      callback()
    } else {
      callback(msg)
    }
  }
}

const vailidateOrgMobile = (rule: any, value: any, callback: any) => {
  if (phoneReg.test(value) || telPhoneReg.test(value)) {
    callback()
  } else {
    callback('可输入11位手机号码或如以下格式的电话号码:0755-12345678')
  }
}

const validatorComfirPassword = (rule: any, value: any, callback: any) => {
  if (value === formData.value.superPassword) {
    callback()
  } else {
    callback('两次输入的密码不一致')
  }
}

const rules: any = {
  orgContact: [{ required: true, message: '请输入' }],
  orgName: [{ required: true, message: '请输入' }],
  address: [
    { required: true, message: '请输入' },
    {
      validator: validatorLocation,
    },
  ],
  superUsernmae: [
    { required: true, message: '请输入' },
    {
      validator: vailidateMethod(accountReg, '请输入4-20位英文或数字'),
    },
  ],
  superPassword: [
    { required: true, message: '请输入' },
    {
      validator: vailidateMethod(passwordReg, '6-30位字符串'),
    },
  ],
  confirmPassword: [
    { required: true, message: '请输入' },
    {
      validator: validatorComfirPassword,
    },
  ],
  orgMobile: [
    { required: true, message: '请输入' },
    {
      validator: vailidateOrgMobile,
    },
  ],
  superMobile: [
    { required: true, message: '请输入' },
    {
      validator: vailidateMethod(phoneReg, '请输入11位手机号码'),
    },
  ],
}

const loading = ref(false)
const formRef: any = ref<FormInstance>()
const handleSubmit = () => {
  formRef.value.validate(async (valid: boolean) => {
    if (valid) {
      const fn = props.data.orgId ? updateTenantInfo : createTenantInfo
      const { address, lng, lat } = mapData.value
      loading.value = true
      const res: any = await fn({
        ...formData.value,
        address,
        locationLat: lat,
        locationLon: lng,
        orgId: props.data.orgId,
        superPassword: encode(formData.value.superPassword || ''),
      }).finally(() => {
        loading.value = false
      })
      if (res?.code === CODE_ENUM.SUCCESS) {
        ElMessage({
          message: props.data.orgId ? '修改租户成功' : '新建租户成功',
          type: 'success',
        })
        cancel()
        $emit('success')
      }
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_drawer, {
      "model-value": props.visible,
      title: props.data.orgId ? '编辑租户' : '新建租户',
      size: "480px",
      "before-close": cancel
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_4, [
          _createVNode(_component_el_button, {
            loading: loading.value,
            type: "primary",
            onClick: handleSubmit
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 确定 ")
            ]),
            _: 1
          }, 8, ["loading"]),
          _createVNode(_component_el_button, { onClick: cancel }, {
            default: _withCtx(() => [
              _createTextVNode("取消")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_el_form, {
            model: formData.value,
            rules: rules,
            ref_key: "formRef",
            ref: formRef,
            "label-position": "left",
            "label-width": "80"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                prop: "orgName",
                label: "租户名称"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: formData.value.orgName,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.orgName) = $event)),
                    maxlength: "20",
                    placeholder: "请输入租户名称"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                prop: "orgContact",
                label: "联系人"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: formData.value.orgContact,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.orgContact) = $event)),
                    maxlength: "50",
                    placeholder: "请输入联系人名称"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                prop: "orgMobile",
                label: "联系电话"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: formData.value.orgMobile,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.orgMobile) = $event)),
                    maxlength: "20",
                    placeholder: "请输入联系人电话"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                prop: "salePerson",
                label: "销售人员"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: formData.value.salePerson,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.salePerson) = $event)),
                    maxlength: "50",
                    placeholder: "请输入销售人员名称"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                prop: "address",
                label: "地址"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_unref(Text), {
                      class: "text-flex",
                      content: formData.value.address
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(formData.value.address), 1)
                      ]),
                      _: 1
                    }, 8, ["content"]),
                    _createVNode(_component_el_button, {
                      plain: "",
                      onClick: toShowMap,
                      class: "btn ws_ml5"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("编辑地址")
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }),
              (!props.data.orgId)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_el_form_item, {
                      class: "ws_form_label",
                      prop: "superUsernmae",
                      label: "超级管理员帐号"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formData.value.superUsernmae,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.superUsernmae) = $event)),
                          maxlength: "20",
                          placeholder: "请输入超级管理员帐号"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      class: "ws_form_label",
                      prop: "superPassword",
                      label: "超级管理员密码"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formData.value.superPassword,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.superPassword) = $event)),
                          maxlength: "50",
                          placeholder: "请输入超级管理员密码",
                          type: "password",
                          "show-password": ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      prop: "confirmPassword",
                      label: "确认密码"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formData.value.confirmPassword,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.confirmPassword) = $event)),
                          maxlength: "50",
                          placeholder: "请输入确认密码",
                          type: "password",
                          "show-password": ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      prop: "superMobile",
                      label: "超级管理员手机号",
                      class: "ws_form_label"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formData.value.superMobile,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.superMobile) = $event)),
                          maxlength: "50",
                          placeholder: "请输入超级管理员手机号"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["model"])
        ])), [
          [_directive_loading, detailLoading.value]
        ])
      ]),
      _: 1
    }, 8, ["model-value", "title"]),
    _createVNode(_unref(MapModal), {
      visible: mapConf.value.visible,
      "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((mapConf.value.visible) = $event)),
      data: mapData.value,
      onOnMapChange: onMapChange
    }, null, 8, ["visible", "data"])
  ], 64))
}
}

})